// extracted by mini-css-extract-plugin
module.exports = {"main_sign":"Login_main_sign__14nmY","upper":"Login_upper__13f1E","divide":"Login_divide__1QYqh","lin":"Login_lin__3E56F","sig_botm":"Login_sig_botm__1tszH"};